module.exports = __webpack_public_path__ + "static/media/universalhall.ce61b2a2.png";